import { render } from "./GlobalQuarantine.vue?vue&type=template&id=1f1a2349&scoped=true&ts=true"
import script from "./GlobalQuarantine.vue?vue&type=script&lang=ts"
export * from "./GlobalQuarantine.vue?vue&type=script&lang=ts"

import "./GlobalQuarantine.vue?vue&type=style&index=0&id=1f1a2349&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1a2349"]])

export default __exports__